module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f642.da3651e5.svg";